import React from 'react'
import Modal from '../../Modal'
import { AdminCustomer } from '../../../types/api'

type AdminCustomerDetailsModalProps = {
  customer: AdminCustomer | null
  isOpen: boolean
  onClose: () => void
  formatCurrency: (value: number) => string
  formatDate: (value?: string | null) => string
}

const AdminCustomerDetailsModal: React.FC<AdminCustomerDetailsModalProps> = ({
  customer,
  isOpen,
  onClose,
  formatCurrency,
  formatDate
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalhes do cliente"
      size="md"
      titleClassName="text-blue-600"
      footer={
        <div className="flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:border-gray-300 hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            Fechar
          </button>
        </div>
      }
    >
      {customer && (
        <div className="space-y-6">
          <section>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
              Informações pessoais
            </h3>
            <div className="mt-3 space-y-2 text-sm text-gray-700">
              <p>
                <span className="font-medium text-gray-900">Nome:</span>{' '}
                {customer.name}
              </p>
              <p>
                <span className="font-medium text-gray-900">E-mail:</span>{' '}
                {customer.email}
              </p>
              <p>
                <span className="font-medium text-gray-900">Telefone:</span>{' '}
                {customer.phone ?? '—'}
              </p>
              <p>
                <span className="font-medium text-gray-900">CPF:</span>{' '}
                {customer.cpf ?? '—'}
              </p>
              <p>
                <span className="font-medium text-gray-900">Status:</span>{' '}
                {customer.isActive ? 'Ativo' : 'Inativo'}
              </p>
              <p>
                <span className="font-medium text-gray-900">Cadastro:</span>{' '}
                {formatDate(customer.registrationDate)}
              </p>
              <p>
                <span className="font-medium text-gray-900">
                  Último pedido:
                </span>{' '}
                {formatDate(customer.lastOrderDate)}
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
              Métricas
            </h3>
            <div className="mt-3 grid gap-3 rounded-lg border border-gray-100 bg-gray-50 p-4 text-sm text-gray-700">
              <p>
                <span className="font-medium text-gray-900">Pedidos:</span>{' '}
                {customer.totalOrders}
              </p>
              <p>
                <span className="font-medium text-gray-900">Total gasto:</span>{' '}
                {formatCurrency(customer.totalSpent)}
              </p>
              <p>
                <span className="font-medium text-gray-900">Ticket médio:</span>{' '}
                {customer.totalOrders > 0
                  ? formatCurrency(customer.totalSpent / customer.totalOrders)
                  : '—'}
              </p>
            </div>
          </section>

          {customer.address && (
            <section>
              <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
                Endereço principal
              </h3>
              <div className="mt-3 space-y-2 rounded-lg border border-gray-100 bg-gray-50 p-4 text-sm text-gray-700">
                <p>
                  <span className="font-medium text-gray-900">Rua:</span>{' '}
                  {customer.address.street ?? '—'},{' '}
                  {customer.address.number ?? '—'}
                </p>
                {customer.address.complement && (
                  <p>
                    <span className="font-medium text-gray-900">
                      Complemento:
                    </span>{' '}
                    {customer.address.complement}
                  </p>
                )}
                <p>
                  <span className="font-medium text-gray-900">Bairro:</span>{' '}
                  {customer.address.neighborhood ?? '—'}
                </p>
                <p>
                  <span className="font-medium text-gray-900">Cidade:</span>{' '}
                  {customer.address.city ?? '—'}{' '}
                  {customer.address.state ? `• ${customer.address.state}` : ''}
                </p>
                <p>
                  <span className="font-medium text-gray-900">CEP:</span>{' '}
                  {customer.address.zipCode ?? '—'}
                </p>
              </div>
            </section>
          )}
        </div>
      )}
    </Modal>
  )
}

export default AdminCustomerDetailsModal

